export default {

  /**
   * @param {String} value    The value string.
   * @param {Number} decimals The number of decimal places.
   */
  round: function(value, decimals) {
    value = Number(value);
    if (!value) {
      value = 0;
    }
    if (!decimals) {
      decimals = 0;
    }
    value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
    return value;
  },

  /**
   * Checks if given number is integer
   * @param  {Number}  n Number to check
   * @return {Boolean}   True if integer
   */
  isInt: function(n) {
    return Number(n) === n && n % 1 === 0;
  },

  /**
   * Checks if given number is float
   * @param  {Number}  n Number to check
   * @return {Boolean}   True if float
   */
  isFloat: function(n) {
    return Number(n) === n && n % 1 !== 0;
  }
}



// WEBPACK FOOTER //
// ./src/utils/numberUtils.js